import { PlusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  message,
  Divider,
  Spin,
  TreeSelect,
  InputNumber,
} from "antd";
import React, { useState } from "react";
import { store } from "../../../redux/configStore";
import { transformData } from "../../../utils/recursive";
import useStoreData from "../../../hooks/useStoreData";
// import { getListService } from "../../../api/serviceProject/service";
import {
  createChangePointSetting,
  getListChangePointSetting,
} from "../../../api/ChangePoint/changePointSetting";

export default function FormAddChangePointSetting({
  isModalOpen,
  handleCancel,
  currentPage,
  pageSize,
}) {
  // const [initialized, setInitialized] = useState(false);
  const { data: allListStore, loading: isLoadStoreAll } = useStoreData();

  const data = transformData(allListStore?.data);
  const options = data?.filter((item) => item.parent_id === 0);


  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [formRef] = Form.useForm();
  const dispatch = useDispatch();

  const onFinish = async (fieldsValue) => {
    const values = { ...fieldsValue };
    setIsLoadCreate(true);

    try {
      const response = await store.dispatch(createChangePointSetting(values));
      if (createChangePointSetting.fulfilled.match(response)) {
        if (response.payload.data.original) {
          message.error(response.payload.data.original.message);
        } else {
          message.success("Thêm mới thành công");
          formRef.resetFields();
          handleCancel();
          await store.dispatch(
            getListChangePointSetting({ currentPage, pageSize })
          );
        }
      } else if (createChangePointSetting.rejected.match(response)) {
        handleErrors(response);
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi khi tạo.");
    } finally {
      setIsLoadCreate(false);
    }
  };

  // Hàm xử lý lỗi từ API
  const handleErrors = (response) => {
    if (response.payload.errors) {
      Object.keys(response.payload.errors).forEach((field) => {
        const errorMessages = response.payload.errors[field];
        errorMessages.forEach((errorMessage) => {
          message.error(errorMessage);
        });
      });
    } else if (response.payload.error) {
      message.error(response.payload.error);
    }
    if (response.payload.message) {
      message.error(response.payload.message);
    }
  };

  return (
    <Modal
      title="Thiết lập cấu hình gửi điểm"
      open={isModalOpen}
      footer={null}
      onCancel={handleCancel}
      width={600}
    >
      <Form
        name="addAppManagement"
        form={formRef}
        onFinish={onFinish}
        layout="vertical"
        requiredMark=""
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Đơn vị"
              name="mcoupon_branch_id"
              rules={[{ required: true, message: "Vui lòng chọn đơn vị" }]}
            >
              {isLoadStoreAll ? (
                <Spin />
              ) : (
                <TreeSelect
                  allowClear
                  showSearch
                  treeLine
                  treeData={options}
                  placeholder="Vui lòng chọn đơn vị"
                  filterTreeNode={(inputValue, treeNode) =>
                    treeNode.title
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                />
              )}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Số dư tối thiểu (Điểm)"
              name="minimum_balance"
              rules={[
                { required: true, message: "Vui lòng nhập số dư tối thiểu" },
                {
                  type: "number",
                  min: 0,
                  message: "Số dư phải lớn hơn hoặc bằng 0",
                },
              ]}
            >
              <InputNumber
                placeholder="Nhập số dư tối thiểu"
                style={{ width: "100%" }}
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/,/g, "")}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Phí giao dịch (%)"
              name="transaction_fee"
              rules={[
                { required: true, message: "Vui lòng nhập phí giao dịch" },
                {
                  type: "number",
                  min: 0,
                  max: 100,
                  message: "Phí phải từ 0 đến 100%",
                },
              ]}
            >
              <InputNumber
                placeholder="Nhập phí giao dịch"
                style={{ width: "100%" }}
                min={0}
                max={100}
                step={0.01}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusCircleOutlined />}
              loading={isLoadCreate}
              style={{ minWidth: 150 }}
            >
              Thêm mới
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
